import { render } from "./IconChevronRightStroke.vue?vue&type=template&id=8e23e1b0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronRightStroke.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e23e1b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e23e1b0', __exports__)) {
    api.reload('8e23e1b0', __exports__)
  }
  
  module.hot.accept("./IconChevronRightStroke.vue?vue&type=template&id=8e23e1b0", () => {
    api.rerender('8e23e1b0', render)
  })

}


export default __exports__